import { mapGetters } from 'vuex';
import { AuthGetterTypes } from '../../store/getters';

export default {
	computed: {
		...mapGetters({
			viewOwnerCurrentUserId: [AuthGetterTypes.CURRENT_USER_ID],
		}),
	},
	methods: {
		/**
		 * A view stays the property of the user who created it, sharing it as a global view does not
		 * hand it over. The other users get to see it and to pick it as their own default, nothing
		 * more, so renaming/editing/deleting/unsharing it is hidden from them.
		 * The base view of a grid has no owner and is left to the callers to deal with.
		 * @param view {object}
		 * @return {boolean}
		 */
		isViewOwner(view) {
			if (!view || view.UserId == null) return false;
			if (!this.viewOwnerCurrentUserId) return false;
			//the guid comes from the api on one side and from the jwt on the other, casing can differ
			return (
				String(view.UserId).toLowerCase() ===
				String(this.viewOwnerCurrentUserId).toLowerCase()
			);
		},
	},
};
